import { NewsIndexClient } from 'hb-react/frontoffice/apps/NewsIndex/startup/NewsIndexClient';

const NewsAppClient = ({ _baseUrl, ...props }) => (
  <NewsIndexClient config={props.config} topic={props.topic} />
);

export default NewsAppClient;
